import AppUa from './app.ua';
import AppUserFeedback from './app.user.feedback';
const Layout = () => import('@/layouts/index.vue');
const routes = {
    path: '/app',
    component: Layout,
    // redirect: '/user/list',
    name: 'App',
    meta: {
        title: 'App',
        icon: 'carbon:application-mobile',
    },
    children: [
        {
            path: '/app/config',
            name: 'AppConfigList',
            component: () => import('@/views/app/config/list.vue'),
            meta: {
                title: 'App配置',
                icon: 'lucide:user-search',
            },
            children: [
                {
                    path: 'create',
                    name: 'AppConfigCreate',
                    component: () => import('@/views/app/config/detail.vue'),
                    meta: {
                        title: '新增配置',
                        sidebar: false,
                        activeMenu: '/app/config',
                    },
                },
                {
                    path: 'edit/:id',
                    name: 'AppConfigEdit',
                    component: () => import('@/views/app/config/detail.vue'),
                    meta: {
                        title: '编辑配置',
                        sidebar: false,
                        activeMenu: '/app/config',
                    },
                },
            ],
        },
        {
            path: '/app/popup/message',
            name: 'AppPopupMessageList',
            component: () => import('@/views/app/popup/message/list.vue'),
            meta: {
                title: '弹窗消息',
                icon: 'carbon:notification',
            },
            children: [
                {
                    path: 'create',
                    name: 'AppPopupMessageCreate',
                    component: () => import('@/views/app/popup/message/detail.vue'),
                    meta: {
                        title: '新增消息',
                        sidebar: false,
                        activeMenu: '/app/popup/message',
                    },
                },
                {
                    path: 'detail/:id',
                    name: 'AppPopupMessageDetail',
                    component: () => import('@/views/app/popup/message/detail.vue'),
                    meta: {
                        title: '消息详情',
                        sidebar: false,
                        activeMenu: '/app/popup/message',
                    },
                },
            ],
        },
        AppUa,
        AppUserFeedback,
    ],
};
export default routes;
